import {createContext} from "react";
import {StaffLinkAddedDetails} from "../Pages/AdminCalendarEntry/Helpers/calenderEntryHelpers";

/** Context that is sorted set in the groups of a calendar entry. Provided staff for all child components when sorted in the group*/
export const AvailableStaffLinkListContext = createContext<StaffLinkAddedDetails[]>([]);
